(function () {
  var clickableCardsBound = false;

  function isInteractiveTarget(target) {
    return !!target.closest('a, button, input, select, textarea, form, product-form, .slick-arrow, .slick-dots');
  }

  function initClickableCards() {
    if (clickableCardsBound) return;
    clickableCardsBound = true;

    document.addEventListener('click', function (event) {
      var card = event.target.closest('.my-product-slider-item.card-clickable');
      if (!card) return;
      if (isInteractiveTarget(event.target)) return;

      var url = card.getAttribute('data-card-url');
      if (url) window.location.href = url;
    });
  }

  function initCustomProductSliders() {
    if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) return;

    window.jQuery('.my-product-slider').each(function () {
      var $slider = window.jQuery(this);
      if ($slider.hasClass('my-product-slider--static')) return;
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('setPosition');
        return;
      }

      $slider.on('init', function () {
        setTimeout(function () { $slider.slick('setPosition'); }, 0);
        setTimeout(function () { $slider.slick('setPosition'); }, 200);
      });
      $slider.slick({
        infinite: true,
        speed: 300,
        autoplay: false,
        autoplaySpeed: 2000,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '60px',
              infinite: true
            }
          }
        ]
      });
    });
  }

  function boot() {
    initClickableCards();
    initCustomProductSliders();
    window.addEventListener('home:enhancements-ready', initCustomProductSliders);
    document.addEventListener('shopify:section:load', initCustomProductSliders);
    window.addEventListener('load', function () { setTimeout(initCustomProductSliders, 100); });
    window.addEventListener('resize', function () { setTimeout(initCustomProductSliders, 80); });
  }

  window.initCustomProductSliders = initCustomProductSliders;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
